import utils from '../../utils'

export const products = [
  {
    "id": 1,
    "product_id": "FLEET_MANAGEMENT",
    "product_name": "VM Vendors Fleet Management",
    "product_description": "VM Vendors Fleet Management for IT Trips",
    "product_price": 50,
    "product_currency": "INR",
  }, {
    "id": 2,
    "product_id": "ONCALL_MANAGEMENT",
    "product_name": "VM Vendors OnCall Management",
    "product_description": "VM Vendors OnCall Management for Outstation Trips",
    "product_price": 100,
    "product_currency": "INR",
    "display": true
  }, {
    "id": 3,
    "product_id": "SCHOOOL_MANAGEMENT",
    "product_name": "VM Vendors School Management",
    "product_description": "VM Vendors School Management for School Trips",
    "product_price": 100,
    "product_currency": "INR",
    "display": true
  }, {
    "id": 4,
    "product_id": "MIS_MANAGEMENT",
    "product_name": "VM Vendors MIS Management",
    "product_description": "VM Vendors MIS Management for MIS Trips",
    "product_price": 100,
    "product_currency": "INR",
    "display": true
  }, {
    "id": 5,
    "product_id": "BOTH",
    "product_name": "VM Vendors Both Products",
    "product_description": "VM Vendors Both Products",
    "product_price": 100,
    "product_currency": "INR",
    "display": false
  }, {
    "id": 6,
    "product_id": "NOT_PUBLIC_RIDES",
    "product_name": "NOT Public Rides Products",
    "product_description": "NOT Public Rides using rides dynamic",
    "product_price": 100,
    "product_currency": "INR",
    "display": false
  }
]

export const PlanFeatures = [
  {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "_card_view": 1,
    "_detailed_view": 1,
    // Permanently disable all except View
    "_create_permanently_disabled": true,
    "_edit_permanently_disabled": true,
    "_delete_permanently_disabled": true,
    "_card_view_permanently_disabled": true,
    "_detailed_view_permanently_disabled": true,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vendorDashboard",
    "has_feature": 1,
    "feature_name": "Dashboard",
    "product_id": "BOTH",
    "has_view_setting": false,
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Alert & Due",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_dashboard_alert_due",
        "feature_name": "vendor_dashboard_alert_due",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 1,
        "_detailed_view": 1,
        // Permanently disable all except View
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
        "_detailed_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Expense Analysis",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_dashboard_expense_analysis",
        "feature_name": "vendor_dashboard_expense_analysis",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 1,
        "_detailed_view": 1,
        // Permanently disable all except View
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
        "_detailed_view_permanently_disabled": true,
      }
    ],
    "selected_view_settings_value": ""
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_aiChatPrompt",
    "has_feature": 1,
    "feature_name": "AI Chat Prompt",
    "product_id": "BOTH",
    "has_view_setting": false,
    "view_settings_options": [],
    "_create_permanently_disabled": true,
    "_edit_permanently_disabled": true,
    "_delete_permanently_disabled": true,
    "_card_view_permanently_disabled": true,
  },
  {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_subvendormanagement",
    "has_feature": 1,
    "feature_name": "Vendor Management",
    "has_view_setting": false,
    "view_settings_options": [],
    "product_id": "FLEET_MANAGEMENT",
    "selected_view_settings_value": "",
    "_create_permanently_disabled": true,
    "_edit_permanently_disabled": true,
    "_delete_permanently_disabled": true,
    "_card_view_permanently_disabled": true,
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vendorClient",
    "has_feature": 1,
    "feature_name": "Vendor Client",
    "has_view_setting": false,
    "product_id": "ONCALL_MANAGEMENT",
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vendorBilling",
    "has_feature": 1,
    "feature_name": "Billing",
    "product_id": "ONCALL_MANAGEMENT",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "_detailed_view": 1,
    "_create_permanently_disabled": true,
    "_edit_permanently_disabled": true,
    "_delete_permanently_disabled": true,
    "_detailed_view_permanently_disabled": false,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_employeeManagement",
    "has_feature": 1,
    "feature_name": "Employee Management",
    "has_view_setting": false,
    "product_id": "FLEET_MANAGEMENT",
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Active Employees",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_activeEmployees",
        "feature_name": "vendor_activeEmployees",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_detailed_view": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
        "_detailed_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Add Employee",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_addEmployee",
        "feature_name": "vendor_addEmployee",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_detailed_view": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
        "_detailed_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Attendance Plot",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_attendancePlot",
        "feature_name": "vendor_attendancePlot",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_detailed_view": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
        "_detailed_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Attendance Calendar",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_attendanceCalendar",
        "feature_name": "vendor_attendanceCalendar",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_detailed_view": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
        "_detailed_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Inactive Employees",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_inactiveEmployees",
        "feature_name": "vendor_inactiveEmployees",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_detailed_view": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
        "_detailed_view_permanently_disabled": false,
      }
    ],
    "selected_view_settings_value": ""
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_branchMangement",
    "has_feature": 1,
    "feature_name": "Branch Management",
    "has_view_setting": false,
    "product_id": "FLEET_MANAGEMENT",
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Active Branches",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_activeBranches",
        "feature_name": "vendor_activeBranches",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Add Branch",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_addBranch",
        "feature_name": "vendor_addBranch",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Inactive Branches",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_inactiveBranches",
        "feature_name": "vendor_inactiveBranches",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": false,
      }
    ],
    "selected_view_settings_value": ""
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_dayBookManagement",
    "has_feature": 1,
    "feature_name": "Day Book Management",
    "has_view_setting": false,
    "product_id": "FLEET_MANAGEMENT",
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Day Book Entry",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_dayBookEntry",
        "feature_name": "vendor_dayBookEntry",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 1,
        "_detailed_view": 1,
      }, {
        "id": utils.getUniqueId(),
        "name": "Add Day Book Entry",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_addDayBookEntry",
        "feature_name": "vendor_addDayBookEntry",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
      }
    ],
    "selected_view_settings_value": ""
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_emiManagement",
    "has_feature": 1,
    "feature_name": "EMI Management",
    "has_view_setting": false,
    "product_id": "FLEET_MANAGEMENT",
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Overview EMI/Loan",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_overviewEmiLoan",
        "feature_name": "vendor_overviewEmiLoan",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 1,
        "_detailed_view": 1,
      }, {
        "id": utils.getUniqueId(),
        "name": "EMI/Loan Schedules",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_emiSchedules",
        "feature_name": "vendor_emiSchedules",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 1,
        "_detailed_view": 1,
      }
    ],
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_gpsManagement",
    "has_feature": 1,
    "feature_name": "Gps Management",
    "has_view_setting": false,
    "product_id": "FLEET_MANAGEMENT",
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Active Gps",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_activeGps",
        "feature_name": "vendor_activeGps",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 1,
        "_detailed_view": 1,
      }, {
        "id": utils.getUniqueId(),
        "name": "Add Gps",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_addGps",
        "feature_name": "vendor_addGps",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
      },       {
        "id": utils.getUniqueId(),
        "name": "Gps Vendor",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_gpsVendor",
        "feature_name": "vendor_gpsVendor",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 1,
        "_detailed_view": 1,
      }
    ],
    "selected_view_settings_value": ""
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_loanManagement",
    "has_feature": 1,
    "feature_name": "Loan Management",
    "has_view_setting": false,
    "product_id": "FLEET_MANAGEMENT",
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Active Emi/Loan",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_activeEmiLoan",
        "feature_name": "vendor_activeEmiLoan",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 1,
        "_detailed_view": 1,
      }, {
        "id": utils.getUniqueId(),
        "name": "Add Emi/Loan",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_addEmiLoan",
        "feature_name": "vendor_addEmiLoan",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
      },       {
        "id": utils.getUniqueId(),
        "name": "Inactive Emi/Loan",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_inactiveEmiLoan",
        "feature_name": "vendor_inactiveEmiLoan",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 1,
        "_detailed_view": 1,
      },       {
        "id": utils.getUniqueId(),
        "name": "All Banks",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_allBanks",
        "feature_name": "vendor_allBanks",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 1,
        "_detailed_view": 1,
      }
    ],
    "selected_view_settings_value": ""
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_storeManagement",
    "has_feature": 1,
    "feature_name": "Store Management",
    "has_view_setting": false,
    "product_id": "FLEET_MANAGEMENT",
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Service Invoices",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_serviceInvoices",
        "feature_name": "vendor_serviceInvoices",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 1,
        "_detailed_view": 1,
      },       {
        "id": utils.getUniqueId(),
        "name": "Active Service Centres",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_activeServiceCentres",
        "feature_name": "vendor_activeServiceCentres",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 1,
        "_detailed_view": 1,
      }, {
        "id": utils.getUniqueId(),
        "name": "Add New Service Centre",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_addNewServiceCentre",
        "feature_name": "vendor_addNewServiceCentre",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
      }
    ],
    "selected_view_settings_value": ""
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_InvoiceManagement",
    "has_feature": 1,
    "feature_name": "InVoice",
    "has_view_setting": false,
    "product_id": "FLEET_MANAGEMENT",
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Inventory Invoices",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_inventoryInvoices",
        "feature_name": "vendor_inventoryInvoices",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Inventory Items",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_inventoryItems",
        "feature_name": "vendor_inventoryItems",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }
    ],
    "selected_view_settings_value": ""
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_publicRides",
    "has_feature": 1,
    "feature_name": "Public Rides",
    "has_view_setting": false,
    "product_id": "BOTH",
    "view_settings_options": [],
    "selected_view_settings_value": "",
    "_create_permanently_disabled": true,
    "_edit_permanently_disabled": true,
    "_delete_permanently_disabled": true,
    "_card_view_permanently_disabled": true,
    
  },
  {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_studentmanagement",
    "has_feature": 1,
    "feature_name": "School - Student Management",
    "has_view_setting": false,
    "product_id": "SCHOOOL_MANAGEMENT",
    "view_settings_options": [],
    "selected_view_settings_value": ""
  },
  {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_studentcaretaker",
    "has_feature": 1,
    "feature_name": "School - Caretaker Management",
    "has_view_setting": false,
    "product_id": "SCHOOOL_MANAGEMENT",
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vendorAdhoc",
    "product_id": "ONCALL_MANAGEMENT",
    "has_feature": 1,
    "feature_name": "Adhoc Management",
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vendorContractor",
    "product_id": "ONCALL_MANAGEMENT",
    "has_feature": 1,
    "feature_name": "Contractor Management",
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_itTripsManagement",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "IT Trips",
    "has_view_setting": false,
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Trip Card Section",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "itTrips_trip_card_section",
        "feature_name": "itTrips_trip_card_section",
      },
      {
        "id": utils.getUniqueId(),
        "name": "Trip Status",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "itTrips_trip_status",
        "feature_name": "itTrips_trip_status",
      }, {
        "id": utils.getUniqueId(),
        "name": "Trip View",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "itTrips_trip_view",
        "feature_name": "itTrips_trip_view",
      }, {
        "id": utils.getUniqueId(),
        "name": "Fleet Payment",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "itTrips_fleet_payment",
        "feature_name": "itTrips_fleet_payment",
      }, {
        "id": utils.getUniqueId(),
        "name": "All Trips",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_itAllTrips",
        "feature_name": "vendor_itAllTrips",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Schedule Trips",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_itScheduleTrips",
        "feature_name": "vendor_itScheduleTrips",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Calendar",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_itCalendar",
        "feature_name": "vendor_itCalendar",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Master Data",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_itMasterData",
        "feature_name": "vendor_itMasterData",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Replaced Trips",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_itReplacedTrips",
        "feature_name": "vendor_itReplacedTrips",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }
    ],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vendorPassenger",
    "has_feature": 1,
    "product_id": "ONCALL_MANAGEMENT",
    "feature_name": "Passenger Management",
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vendorBookedAgent",
    "has_feature": 1,
    "product_id": "ONCALL_MANAGEMENT",
    "feature_name": "Booked Agent Management",
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vendorOncallReport",
    "has_feature": 1,
    "product_id": "ONCALL_MANAGEMENT",
    "feature_name": "Oncall Report",
  },
  {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_tripmanagement",
    "has_feature": 1,
    "product_id": "ONCALL_MANAGEMENT",
    "feature_name": "Trip Management",
    "has_view_setting": false,
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Allocation Management",
        "has_feature": 1,
        "product_id": "ONCALL_MANAGEMENT",
        "feature_key": "trip_allocation_management",
        "feature_name": "trip_allocation_management",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Live Tracking Trips",
        "has_feature": 1,
        "product_id": "ONCALL_MANAGEMENT",
        "feature_key": "trip_live_tracking_trips",
        "feature_name": "trip_live_tracking_trips",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Today's Trip",
        "has_feature": 1,
        "product_id": "ONCALL_MANAGEMENT",
        "feature_key": "onCallTodayTrip",
        "feature_name": "onCallTodayTrip",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Cancel Trips",
        "has_feature": 1,
        "product_id": "ONCALL_MANAGEMENT",
        "feature_key": "onCallCancelTrip",
        "feature_name": "onCallCancelTrip",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Completed Trips",
        "has_feature": 1,
        "product_id": "ONCALL_MANAGEMENT",
        "feature_key": "trip_completed_trips",
        "feature_name": "trip_completed_trips",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "All Trips",
        "has_feature": 1,
        "product_id": "ONCALL_MANAGEMENT",
        "feature_key": "vendor_allTrips",
        "feature_name": "vendor_allTrips",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      },       {
        "id": utils.getUniqueId(),
        "name": "Schedule Trips",
        "has_feature": 1,
        "product_id": "ONCALL_MANAGEMENT",
        "feature_key": "vendor_scheduleTrips",
        "feature_name": "vendor_scheduleTrips",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
      }, {
        "id": utils.getUniqueId(),
        "name": "Calendar",
        "has_feature": 1,
        "product_id": "ONCALL_MANAGEMENT",
        "feature_key": "vendor_tripCalendar",
        "feature_name": "vendor_tripCalendar",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
      }, {
        "id": utils.getUniqueId(),
        "name": "Master Data",
        "has_feature": 1,
        "product_id": "ONCALL_MANAGEMENT",
        "feature_key": "vendor_tripMasterData",
        "feature_name": "vendor_tripMasterData",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
      },       {
        "id": utils.getUniqueId(),
        "name": "Replaced Trips",
        "has_feature": 1,
        "product_id": "ONCALL_MANAGEMENT",
        "feature_key": "vendor_replacedTrips",
        "feature_name": "vendor_replacedTrips",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
      }
    ],
    "selected_view_settings_value": ""
  },
  {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_tripID",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Trip ID",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_excort",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Excort",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_pickUpDropOff",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Pick Up Drop Off",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_billableKm",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Billable KM",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_passengerCount",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Passenger Count",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_tripSheetImg",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Trip Sheet Image Upload",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_routeName",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Route Name",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_drivermanagement",
    "has_feature": 1,
    "product_id": "BOTH",
    "feature_name": "Driver Management",
    "has_view_setting": false,
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Card Section",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "driver_card_section",
        "feature_name": "driver_card_section",
      }, {
        "id": utils.getUniqueId(),
        "name": "Table View Section",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "driver_table_view_section",
        "feature_name": "driver_table_view_section",
      },       {
        "id": utils.getUniqueId(),
        "name": "Driver Attendance Calendar",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "driver_attendance_calendar",
        "feature_name": "driver_attendance_calendar",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Driver Salary",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "driver_salary_management",
        "feature_name": "driver_salary_management",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Driver Live Tracking ",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "driver_live_tracking",
        "feature_name": "driver_live_tracking",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      },       {
        "id": utils.getUniqueId(),
        "name": "Supporting Staff",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "driver_supporting_staff",
        "feature_name": "driver_supporting_staff",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": true,
      },       {
        "id": utils.getUniqueId(),
        "name": "Active Drivers",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_activeDrivers",
        "feature_name": "vendor_activeDrivers",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Attendance Plot",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_driverAttendancePlot",
        "feature_name": "vendor_driverAttendancePlot",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Calendar",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_driverCalendar",
        "feature_name": "vendor_driverCalendar",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 0,
        "_detailed_view": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
        "_detailed_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Driver Performance",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_driverPerformance",
        "feature_name": "vendor_driverPerformance",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Add New Driver",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_addNewDriver",
        "feature_name": "vendor_addNewDriver",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Inactive Drivers",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_inactiveDrivers",
        "feature_name": "vendor_inactiveDrivers",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }
    ],
    "selected_view_settings_value": ""
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_ParivahanApi",
    "has_feature": 1,
    "product_id": "BOTH",
    "feature_name": "Parivahan API",
    "has_view_setting": false,
    "view_settings_options": [{
      "id": utils.getUniqueId(),
      "name": "Parivahan Auto Hit",
      "has_feature": 1,
      "product_id": "BOTH",
      "feature_key": "parivahan_auto_hit",
      "feature_name": "parivahan_auto_hit",
    }],
    "selected_view_settings_value": ""
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_SupportTickets",
    "has_feature": 1,
    "product_id": "BOTH",
    "feature_name": "Support Tickets",
    "has_view_setting": false,
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Create Ticket",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_createTicket",
        "feature_name": "vendor_createTicket",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 0,
        "_detailed_view": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
        "_detailed_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Ticket Management",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_ticketManagement",
        "feature_name": "vendor_ticketManagement",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 0,
        "_detailed_view": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": false,
        "_detailed_view_permanently_disabled": false,
      }
    ],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_monthTarget",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Month Target",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vehicleTracking",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Vehicle Tracking",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vehiclemanagement",
    "has_feature": 1,
    "product_id": "BOTH",
    "feature_name": "Vehicle Management",
    "has_view_setting": false,
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Card Section",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_name": "vehicle_card_section",
      }, {
        "id": utils.getUniqueId(),
        "name": "Table View Section",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_name": "vehicle_table_view_section",
      }, {
        "id": utils.getUniqueId(),
        "name": "Vehicle Attendance Calendar",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_name": "vehicle_attendance_calendar",
      },       {
        "id": utils.getUniqueId(),
        "name": "Active Vehicles",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_activeVehicles",
        "feature_name": "vendor_activeVehicles",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Vehicle Traffic Fines",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_vehicleTrafficFines",
        "feature_name": "vendor_vehicleTrafficFines",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Vehicle Attendance Plot",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_vehicleAttendancePlot",
        "feature_name": "vendor_vehicleAttendancePlot",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Vehicle Attendance",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_vehicleAttendance",
        "feature_name": "vendor_vehicleAttendance",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Vehicle Performance",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_vehiclePerformance",
        "feature_name": "vendor_vehiclePerformance",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Add New Vehicle",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_addNewVehicle",
        "feature_name": "vendor_addNewVehicle",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Inactive Vehicles",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_inactiveVehicles",
        "feature_name": "vendor_inactiveVehicles",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }
    ],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_VendorsAggregator",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Aggregator Management",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vendorVehicleInspection",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Vendor Vehicle Inspection",
    "has_view_setting": false,
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Self Inspection Vehicles",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_selfInspectionVehicles",
        "feature_name": "vendor_selfInspectionVehicles",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Weekly Vehicle Inspection",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_weeklyVehicleInspection",
        "feature_name": "vendor_weeklyVehicleInspection",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": true,
      }
    ],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vendorSiteManagement",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Site Management",
    "has_view_setting": false,
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Dashboard",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_siteDashboard",
        "feature_name": "vendor_siteDashboard",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Sites",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_sites",
        "feature_name": "vendor_sites",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": true,
      }
    ],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vendorSupervisors",
    "has_feature": 1,
    "product_id": "BOTH",
    "feature_name": "Vendor Supervisors ",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": "",
    "_create_permanently_disabled": false,
    "_edit_permanently_disabled": false,
    "_delete_permanently_disabled": false,
    "_card_view_permanently_disabled": false,
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vendorTemplate",
    "has_feature": 1,
    "product_id": "BOTH",
    "feature_name": "Vendor Template",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": "",
    "_create_permanently_disabled": false,
    "_edit_permanently_disabled": true,
    "_delete_permanently_disabled": true,
    "_card_view_permanently_disabled": true,
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_customReport",
    "has_feature": 1,
    "product_id": "BOTH",
    "feature_name": "Custom Report",
    "has_view_setting": false,
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Custom Report",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_customReportMain",
        "feature_name": "vendor_customReportMain",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 0,
        "_detailed_view": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
        "_detailed_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Salary Template",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_salaryTemplate",
        "feature_name": "vendor_salaryTemplate",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 0,
        "_detailed_view": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
        "_detailed_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Table Creator Template",
        "has_feature": 1,
        "product_id": "BOTH",
        "feature_key": "vendor_tableCreatorTemplate",
        "feature_name": "vendor_tableCreatorTemplate",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 0,
        "_detailed_view": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
        "_detailed_view_permanently_disabled": true,
      }
    ],
    "selected_view_settings_value": ""
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "third_party_fuels_api",
    "has_feature": 1,
    "product_id": "BOTH",
    "feature_name": "Third Party Fuels API",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_expensesManagement",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Expenses Management",
    "has_view_setting": false,
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Add New Expense",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_addNewExpense",
        "feature_name": "vendor_addNewExpense",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_card_view": 1,
        "_detailed_view": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
        "_detailed_view_permanently_disabled": true,
      }
    ],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_fuelExpenses",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Fuel Management",
    "has_view_setting": false,
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Dashboard",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_fuelDashboard",
        "feature_name": "vendor_fuelDashboard",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Mileage Report",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_mileageReport",
        "feature_name": "vendor_mileageReport",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Fuel Calendar",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_fuelCalendar",
        "feature_name": "vendor_fuelCalendar",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Fuel Entry (To Vehicle)",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_fuelEntryVehicle",
        "feature_name": "vendor_fuelEntryVehicle",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Fuel Entry (To Bowser)",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_fuelEntryBowser",
        "feature_name": "vendor_fuelEntryBowser",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "Fuel Station",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_fuelStation",
        "feature_name": "vendor_fuelStation",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "BPCL",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_bpcl",
        "feature_name": "vendor_bpcl",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": true,
      }
    ],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_adblueManagement",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "AdBlue Management",
    "has_view_setting": false,
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "AdBlue Purchase",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_adbluePurchase",
        "feature_name": "vendor_adbluePurchase",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": false,
      }, {
        "id": utils.getUniqueId(),
        "name": "AdBlue Distribution",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_adblueDistribution",
        "feature_name": "vendor_adblueDistribution",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "AdBlue Entry (To Vehicle)",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_adblueEntryVehicle",
        "feature_name": "vendor_adblueEntryVehicle",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "AdBlue Return Record",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_adblueReturnRecord",
        "feature_name": "vendor_adblueReturnRecord",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": false,
        "_edit_permanently_disabled": false,
        "_delete_permanently_disabled": false,
        "_card_view_permanently_disabled": true,
      }
    ],
    "selected_view_settings_value": ""
  }, {

    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_rtoExpenses",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "RTO Expenses",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_electricalExpenses",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Electrical Expenses",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_thinkeringExpenses",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Thinkering & Painting Expenses",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_batteryManagement",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Battery Management",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_tyreManagement",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Tyre Management",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_mechanicalExpenses",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Mechanical Expenses",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_otherExpenses",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Other Expenses",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_rolemanagement",
    "has_feature": 1,
    "product_id": "BOTH",
    "feature_name": "Role Management",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": "",
    "_view": 0,
    "_create": 0,
    "_edit": 0,
    "_delete": 0,
    "_card_view": 0,
    "_detailed_view": 0,
    "_view_permanently_disabled": false,
    "_create_permanently_disabled": false,
    "_edit_permanently_disabled": false,
    "_delete_permanently_disabled": false,
    "_card_view_permanently_disabled": false,
    "_detailed_view_permanently_disabled": false,
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vendorServices",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Services Management",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": "",
    "_create_permanently_disabled": false,
    "_edit_permanently_disabled": false,
    "_delete_permanently_disabled": false,
    "_card_view_permanently_disabled": false,
    
  },{
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_tyreModule",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Custom Modules",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  },
  {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_onCallServices",
    "has_feature": 1,
    "product_id": "ONCALL_MANAGEMENT",
    "feature_name": "On Call Services",
    "has_view_setting": false,
    "view_settings_options": [
      {
        id: utils.getUniqueId(),
        name: "Self Booking",
        has_feature: 1,
        product_id: "ONCALL_MANAGEMENT",
        feature_key: "onCallSelfBooking",
        feature_name: "Self Booking",
      }, {
        id: utils.getUniqueId(),
        name: "Cancel Booking",
        has_feature: 1,
        product_id: "ONCALL_MANAGEMENT",
        feature_key: "onCallCancelBooking",
        feature_name: "Cancel Booking",
      }, {
        id: utils.getUniqueId(),
        name: "Today's Booking",
        has_feature: 1,
        product_id: "ONCALL_MANAGEMENT",
        feature_key: "onCallTodayBooking",
        feature_name: "Today's Booking",
      }, {
        id: utils.getUniqueId(),
        name: "Client Bookings",
        has_feature: 1,
        product_id: "ONCALL_MANAGEMENT",
        feature_key: "onCallClientBookings",
        feature_name: "Client Bookings",
      }
    ],
    "selected_view_settings_value": ""
  },
  // {
  //   "id": utils.getUniqueId(),
  //   "_edit": 1,
  //   "_view": 1,
  //   "_create": 1,
  //   "_delete": 1,
  //   "has_add": 1,
  //   "has_edit": 1,
  //   "has_view": 1,
  //   "has_delete": 1,
  //   "feature_key": "vendor_fareDatabase",
  //   "has_feature": 1,
  //   "product_id": "FLEET_MANAGEMENT",
  //   "feature_name": "Fare Database",
  //   "has_view_setting": false,
  //   "view_settings_options": [],
  //   "selected_view_settings_value": ""
  // },R
  {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_VendorReports",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Vendor Reports",
    "has_view_setting": false,
    "view_settings_options": [
      {
        "id": utils.getUniqueId(),
        "name": "Profit & Loss Report",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_profitLossReport",
        "feature_name": "vendor_profitLossReport",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Fuel Report",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_fuelReport",
        "feature_name": "vendor_fuelReport",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Tripsheet Report",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_tripsheetReport",
        "feature_name": "vendor_tripsheetReport",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Mechanical Report",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_mechanicalReport",
        "feature_name": "vendor_mechanicalReport",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Supervisor Attendance Report",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_supervisorAttendanceReport",
        "feature_name": "vendor_supervisorAttendanceReport",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Tyre Purchase Report",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_tyrePurchaseReport",
        "feature_name": "vendor_tyrePurchaseReport",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      },       {
        "id": utils.getUniqueId(),
        "name": "Tyre Expenses Report",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_tyreExpensesReport",
        "feature_name": "vendor_tyreExpensesReport",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Battery Purchase Report",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_batteryPurchaseReport",
        "feature_name": "vendor_batteryPurchaseReport",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Battery Expenses Report",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_batteryExpensesReport",
        "feature_name": "vendor_batteryExpensesReport",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "RTO Report",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_rtoReport",
        "feature_name": "vendor_rtoReport",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Others Report",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_othersReport",
        "feature_name": "vendor_othersReport",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Driver Salary Report",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_driverSalaryReport",
        "feature_name": "vendor_driverSalaryReport",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Driver Report",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_supervisorDriverReport",
        "feature_name": "vendor_supervisorDriverReport",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }, {
        "id": utils.getUniqueId(),
        "name": "Site Report",
        "has_feature": 1,
        "product_id": "FLEET_MANAGEMENT",
        "feature_key": "vendor_supervisorSiteReport",
        "feature_name": "vendor_supervisorSiteReport",
        "_view": 1,
        "_create": 1,
        "_edit": 1,
        "_delete": 1,
        "_create_permanently_disabled": true,
        "_edit_permanently_disabled": true,
        "_delete_permanently_disabled": true,
        "_card_view_permanently_disabled": true,
      }
    ],
    "selected_view_settings_value": ""
  },
  {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_MISReport",
    "has_feature": 1,
    "product_id": "MIS_MANAGEMENT",
    "feature_name": "MIS Reports",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  },
  {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_vehicleReport",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Vehicle Report",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_fuelPurchaseReport",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Fuel Purchase Report",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_autoTripsheet",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Auto Tripsheet",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_autoTripsheetNotGPS",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Auto Tripsheet Not GPS",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_SignatureServices",
    "has_feature": 1,
    "product_id": "ONCALL_MANAGEMENT",
    "feature_name": "Signature Services",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_customSignature",
    "has_feature": 1,
    "product_id": "ONCALL_MANAGEMENT",
    "feature_name": "Custom Signature Document",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }, {
    "id": utils.getUniqueId(),
    "_edit": 1,
    "_view": 1,
    "_create": 1,
    "_delete": 1,
    "has_add": -1,
    "has_edit": -1,
    "has_view": 1,
    "has_delete": -1,
    "feature_key": "vendor_leasemanagement",
    "has_feature": 1,
    "product_id": "FLEET_MANAGEMENT",
    "feature_name": "Lease Management",
    "has_view_setting": false,
    "view_settings_options": [],
    "selected_view_settings_value": ""
  }
]
